export default __webpack_public_path__ + "static/media/sing.e40f33a4.png";